import { Box, Collapse } from '@mui/material';
import { type ReactNode } from 'react';
import { useBreakpointUp } from '@/hooks/use-breakpoint';

interface PageHeaderBarProps {
  searchExpanded?: boolean;
  searchContent?: ReactNode;
  mainContent: ReactNode;
  onSearchExpanded?: () => void;
  disableBorder?: boolean;
}

export default function PageHeaderBar({
  searchExpanded = false,
  searchContent,
  mainContent,
  onSearchExpanded,
  disableBorder = false,
}: PageHeaderBarProps) {
  const isLgAndUp = useBreakpointUp('lg');

  return (
    <Box
      sx={{
        'bgcolor': 'background.paper',
        'borderRadius': 2,
        'border': disableBorder ? 'none' : '1px solid',
        'borderColor': 'divider',
        'boxShadow': '0 1px 3px rgba(0, 0, 0, 0.05)',
        'transition': 'all 0.2s ease-in-out',
        '&:hover': {
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
        },
      }}
    >
      {/* Expanded search on mobile/small/medium screens */}
      {searchContent && (
        <Collapse in={searchExpanded && !isLgAndUp} onEntered={onSearchExpanded}>
          <Box sx={{ px: { xs: 1, sm: 2 }, py: { xs: 0.5, sm: 1 } }}>{searchContent}</Box>
        </Collapse>
      )}

      {/* Main content - hidden when search is expanded on mobile/small/medium */}
      <Collapse in={!searchExpanded || isLgAndUp}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: { xs: 1, sm: 2 },
            py: { xs: 0.5, sm: 1 },
            gap: { xs: 1, sm: 2 },
            flexWrap: 'nowrap',
          }}
        >
          {mainContent}
        </Box>
      </Collapse>
    </Box>
  );
}
